import React from 'react';

import Layout from 'components/Foundation/Layout';
import SEO from 'components/Foundation/SEO';
import ContactInfo from 'components/ContactInfo';

const ContactPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Contact" />
      <ContactInfo />
    </Layout>
  );
};

export default ContactPage;
